'use strict';

module.exports = function toArray() {
  if (Array.isArray(this.items)) {
    return this.all();
  }

  return this.values().all();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/toArray.js
// module id = 1276
// module chunks = 2